var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgP(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 220,
    height: 220,
    viewBox: "0 0 220 220",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M182.397 88.1086C182.58 126.242 151.765 158.047 113.328 159.278C100.193 159.695 87.8346 156.598 77.1096 150.867V177.385C77.1096 186.973 69.278 194.75 59.6027 194.75C49.9274 194.75 42.105 186.973 42.105 177.385V103.635C46.97 106.922 52.8482 108.841 59.1737 108.841C65.4992 108.841 71.0488 107.03 75.8317 103.898C76.2242 104.776 76.6532 105.645 77.1096 106.487C83.5902 118.438 96.3233 126.568 110.964 126.568C131.967 126.568 149.045 109.837 149.373 89.0773C149.711 68.0189 132.332 50.428 111.101 50.3555C103.142 50.3284 95.73 52.7004 89.5871 56.7926C89.5871 56.4304 89.6053 56.0773 89.6053 55.7152C89.6053 43.8461 82.6774 33.5703 72.6005 28.6815C83.6906 21.665 96.8527 17.6 110.964 17.6C150.295 17.6 182.215 49.1424 182.397 88.1086Z",
    fill: "#FC981B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M59.2562 35.6802C46.9338 35.6802 38.1348 45.7115 38.1348 56.6209C38.1348 60.188 39.0749 63.8366 41.1286 67.2678L57.4854 94.6094C58.2886 95.9493 60.2328 95.9493 61.0361 94.6094L77.3928 67.2678C85.7446 53.3254 75.6129 35.6802 59.2562 35.6802ZM59.2653 62.7863C55.3221 62.7863 52.1275 59.6176 52.1275 55.7065C52.1275 51.7954 55.3221 48.6357 59.2653 48.6357C63.2084 48.6357 66.394 51.8045 66.394 55.7065C66.394 59.6086 63.1993 62.7863 59.2653 62.7863Z",
    fill: "#BE2908"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgP);
export default __webpack_public_path__ + "static/media/P.7a93c92fd6070956fc892395866550b3.svg";
export { ForwardRef as ReactComponent };